class Utils {
    
    static ROUTE_DATA_SEPARATOR_1 = ",";
    static UUID_REGEX = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
    
    // eslint-disable-next-line
    static EMAIL_REGEX = /^((([a-zA-Z0-9])+([a-zA-Z0-9\._-])*)|([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // The email regex has been compromised to match with what the EOWP register form accepts

    static ALPHANUMERIC = /^[0-9a-zA-Z]+$/;

    randomInt() {
        return Math.floor(Math.random() * 10000000000000000);
    }

    verifyEmail(email) {
        if (Utils.isEmpty(email)) return false;
        const valid = Utils.EMAIL_REGEX.test(email) ? true : false;
        return valid;
    }

    verifyAlphaNumberic(string){
        return Utils.ALPHANUMERIC.test(string);
    }

    static numberToCurrency(value) {
        let splitted = value.toString().split(".");
        splitted[0] = splitted[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return splitted.join(".");
    }

    static isEmpty(object) {
        return (typeof object === "undefined" || object === undefined || object == null || object === "");
    }

    static getParameters (url) {
        let params = {};
        let placeholder = document.createElement('a');
        placeholder.href = url;
        let query = placeholder.search.substring(1);
        let vars = query.split('&');
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split('=');
            params[pair[0]] = decodeURIComponent(pair[1]);
        }
        return params;
    }

    /**
     * 
     * @param {*} url 
     * @param {*} parameters looks like this:
     * parameters = [
     *      {name: 'name1', value: 'value1'},
     *      {name: 'name2', value: 'value2'},
     *      {name: 'name3', value: 'value3'},
     * ]
     */
    static generateParameters(url, parameters) {
        if (this.isEmpty(url) || this.isEmpty(parameters) || parameters.length <= 0) return;
        let concatPairs = parameters.map(obj => obj.name + "=" + obj.value);
        let combinedPairs = concatPairs.join('&');
        return url + '?' + combinedPairs;
    }

    /**
     * Check if the needle string is not in the stack string. Stack is a string of values separated with comma
     * @param {*} needle 
     * @param {*} stack 
     */
    static notIn(needle, stack) {
        let samples = stack.split(',');
        return samples.indexOf(needle) < 0;
    }

    static startsWith(needle, stack) {
        let samples = !Utils.isEmpty(stack) ? stack.trim() : stack;
        let find = !Utils.isEmpty(needle) ? needle.trim() : needle;
        return samples.indexOf(find) == 0;
    }

    static extractDateFromTimestamp(dbTimestamp) {
        if (Utils.isEmpty(dbTimestamp)) return dbTimestamp;
        let breakTimestamp = dbTimestamp.split("T");
        return breakTimestamp[0];
    }

    static toISO8601(rawBackendDateFormat){ //Backend datetime format: 2014-11-09T23:57:24.000+0000, considering others
        if (Utils.isEmpty(rawBackendDateFormat)) return rawBackendDateFormat;
        let brokenDateTime = rawBackendDateFormat.split('.');
        if (brokenDateTime.length >= 2 && Utils.isEmpty(brokenDateTime[0])) return rawBackendDateFormat;

        let extractedDateTimePart = brokenDateTime[0].replace(/\//g,"-");
        let finalISO8601Date = extractedDateTimePart.replace(/ /g,"T");
        if(finalISO8601Date.split("T").length > 2){
            let splitDate = finalISO8601Date.split("T");
            finalISO8601Date = splitDate[0] + splitDate[1];
        }
        finalISO8601Date = finalISO8601Date.indexOf("+") >= 0 ? finalISO8601Date.split("+")[0] : finalISO8601Date;
        return finalISO8601Date.concat("+00:00");
    }

    static formatDate(dbTimestamp){
        if (Utils.isEmpty(dbTimestamp)) return dbTimestamp;
        let date = new Date(Utils.toISO8601(dbTimestamp));
        let formattedDate = date.getFullYear() + "-" + (date.getMonth()+1).toString().padStart(2, '0') + "-" + (date.getDate()).toString().padStart(2, '0');
        return formattedDate;
    }

    static loadHeader() {
        let cacheBuster = Math.random() * 10000000000000000;
        let recaptchaScript = window.top.document.createElement('script');
        recaptchaScript.setAttribute('src', '/js/script.js?' + cacheBuster);
        window.top.document.head.appendChild(recaptchaScript);
    }

    static loadScript(scriptUrl, scriptId){
        let srcScript = window.top.document.createElement('script');
        srcScript.setAttribute('src', scriptUrl);
        if(!Utils.isEmpty(scriptId)){
            srcScript.setAttribute('id', scriptId);
        }
        window.top.document.head.appendChild(srcScript);
    }

    static setCookie(cookieName, cookeValue, expireInDays) {
        let date = new Date();
        date.setTime(date.getTime() + (expireInDays * 24 * 60 * 60 * 1000));
        let expires = "expires=" + date.toUTCString();
        top.document.cookie = cookieName + "=" + cookeValue + "; " + expires + "; path=/";
    }

    static removeCookie(cookieName) {
        let date = new Date();
        date.setTime(date.getTime() - 1000);
        let expires = "expires=" + date.toUTCString();
        top.document.cookie = cookieName + "=; " + expires + "; path=/";
    }

    static getCookie(cookieName) {
        let cookieItems = top.document.cookie.split(';');
        let cookie = cookieItems.filter(e => e.indexOf(cookieName) >= 0);
        return cookie.length > 0 ? cookie[0].split("=")[1] : "";
    }

    static forceOpenNewTab(url){
        let anchorTag = document.createElement('a');
        anchorTag.href = url;
        anchorTag.setAttribute('target', '_blank');
        anchorTag.setAttribute('style', 'display:none!important');

        let min = 100000;
        let max = 999999;
        let randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;
        let timestamp = new Date().getTime();
        let anchorId = "genAnchor_" + randomNumber + "-" + timestamp;
        anchorTag.setAttribute('id', anchorId);

        let parentElement = document.querySelector("body");
        parentElement.insertBefore(anchorTag, parentElement.lastChild);
        let anchorNode = document.getElementById(anchorId);
        anchorNode.click();
        anchorNode.parentNode.removeChild(anchorNode);
    }

    static formatNumber(value){
        const valueString = value.toString();
        return valueString.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    static dateExpired(referenceDate, givenDate){
        if(Utils.isEmpty(referenceDate) || Utils.isEmpty(givenDate)) return false;
        const currentDate = new Date(referenceDate);
        const compareDate = new Date(givenDate);
        return compareDate >= currentDate;
    }
}

export default Utils;
